module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia Warner smiled to herself after she read the first line of her horoscope in the morning paper. “Good preplanning brings financial success.” No kidding, she thought. She shook her head and then sipped from the mug of hot coffee she held just below her chin. It amazed her how many people had such faith in these things and read them religiously. She had to admit, though, that even though she was skeptical, she always read it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When she gave it serious thought, she realized that she could empathize with the followers of astrology. All of us have this desperate need to know our futures, she thought, me included. And don’t we all sit back and wonder what different choices we would have made had we known what we know now about ourselves? Would I have married Stephen? Would I have become a real estate agent, or would I have competed with Jason to take firm control of the family’s business?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Questions like those could become tormenting. Perhaps it was better to leave it all to fate, fate and good effort and yes … good preplanning. Thank you, Jeanne Dixon. She laughed aloud. She did feel somewhat giddy this morning. She felt that way because she was optimistic, and there was nothing that made life as full and as rich as waking up feeling optimistic.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The feeling wasn’t unwarranted. Stephen had already called from the Palmer Building to tell her that the Bloomfields, clients interested in the old Rose Hill House, would be at her office a half hour earlier than expected. They were that anxious. Stephen, on the other hand, was cynical about it. It wasn’t characteristic of him to be that way, but as of late his being uncharacteristic had become a characteristic. She tried to ignore it. She didn’t want anything to damage her natural high.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She had listed the Rose Hill House only a little more than a month ago when Ralph Hillerman had come to her office to tell her he was going to definitely move his father into an adult residency very soon. Presently, the old man lived in the big house with Patsy Marshall, a widow Ralph had hired to care for his father; but she was going to move off, and the old man had degenerated considerably during the past month or so.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“After all, he’s nearly ninety,” Ralph told her. He sounded as though his father had abused him by living so long.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Less than a week after she listed the place, the Bloomfields called. She sent them photographs, and they called again for more details. Soon after, they made today’s appointment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia looked up from the yellow Formica kitchen counter. Stephen and she had designed the house, and she had insisted that the kitchen be open and airy. She liked waking up and coming into its brightness. There was a twelve-foot bay window on the east side to welcome in the light of the rising sun. On bright days like this one, when the thin, maple shutters were folded back, there was no need for any lights. Jason always complained about the room when he was in it during the early morning hours. He thought the yellow flower wallpaper was too busy and the light beige tiled floor did little to subdue it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You need sunglasses in here” was his frequent comment. Stephen used to laugh, but lately he was in agreement about it and had been suggesting they call in Jason’s decorator.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If I ever agreed to it,” she told him, “it wouldn’t be Jason’s decorator. He is so swishy. He makes my skin crawl when I’m near him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Stephen didn’t disagree, but that didn’t stop him from bringing it up again. He had brought it up as recently as yesterday. She’d simply ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The counter opened onto the dining room in their long, brick ranch-style home, and from where she was sitting she could see herself clearly in the full-length wall mirror on the far wall: As it was, the room was large, fifteen by twenty, and the mirror exaggerated it. Sometimes she felt a bit silly when there were only the two of them dining.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For a few moments this morning as she looked at herself in the mirror, she felt as though she were staring into the window of another house, looking at a total stranger. Only two days ago she had gone to Nikki’s Salon and had her hair stripped and dyed blond. Then he fluffed and blew it out until she looked like Melissa Grant in her cover girl shot on "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cosmo")]), _vm._v(". Stephen had commented favorably about the model’s look, and Cynthia thought this dramatic change in her appearance might jolt their relationship back on track.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before this she had been wearing her dark brown hair pinned back or brushed straight down over her shoulders. When she pinned it back, she thought it emphasized the smooth lines in her neck, the sharp sculptured curve in her chin and jawbone and the depth of her hazel-green eyes. That was the face Stephen had fallen in love with, the face he had called, “Indian perfect, dramatic like a tribal princess perched atop a palamino horse, your hair dancing in the breeze, the western vista spread out around you, embracing you in your heritage and natural beauty.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Once upon a time he could talk like that, spin words poetically, capture a feeling or a mood in a phrase and turn it over and over like a fine jewel. It was why he was such a successful insurance sales man, why her father was happy when they married and he could come into the family business. He had the gift of language, and he could tell people what they wanted even before they wanted it. Everyone admired him. Even Jason admired him and suffered no apparent jealousy when Stephen was quickly promoted to vice president of the Palmer Agency.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Of course, after their father died, her brother, Jason, became the president of the firm, but it was as if he and Stephen were partners. Jason never seemed to make a serious or important decision without Stephen’s approval anymore. They had such a good business relationship that Cynthia was often jealous of them. She used to wish that Jason would feel more threatened by Stephen. She couldn’t remember them ever having a serious argument, at least none that she knew of or that was conducted in public.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You spend more time with Jason than you do with me, if you think about it,” she once told him, but he just shrugged it off. When she gave it more thought she realized it was hard to have an argument with Stephen. He had a way of isolating himself, retreating into a shell of thoughts. She imagined that he treated Jason the same way, and if there was one thing that Jason couldn’t tolerate, it was being ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She was wise enough to know that she wouldn’t enjoy working with them, so she eschewed the insurance business and went for her realtor’s license instead. She took over an office at the Palmer Building, a modern two-story structure constructed on a two-acre lot her father had bought years and years ago just outside of Woodridge, a small upstate New York Catskill community. From her office on the second floor she could look out at Ulster County and the beautiful Shwangunk mountain range. Sometimes she just sat there staring out at the gently sloping hills and blue sky, either hypnotized by the vista or stimulated by it to think deeply philosophical thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She was starting to do that now, but Shirley Watson, her cleaning girl, turned on the vacuum cleaner in the entranceway, and the noise snapped her out of her reverie. She considered her appearance again. How would these clients today take to this new, glamorous hairdo? she wondered. They were coming up from New York City; the husband was a corporate attorney. They should be cosmopolitan enough, she thought. It was just that she had detected that they had a stereotype image of what people were like in the Catskills: countryfolk whose idea of a good time was the Saturday-night bingo game in the firehouse. Toby Bloomfield had said, “We’re looking for an escape, a place so quiet that the crickets keep you up at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And yet they wanted something big enough to house a number of guests on weekends, their own private retreat. What was better for such purposes than a retired tourist house, a turn-of-the-century structure that was in rather good shape, situated on a back country road with nearly twenty acres of flat land and rolling hills. There was even a lake on the property, big enough for rowboats and light fishing. She explained to the Bloomfields that the Rose Hill House had begun as a farmhouse and expanded into a tourist house. “As farming became more difficult and tourism became more profitable.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How interesting,” Toby Bloomfield squealed over the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ordinarily that might have put Cynthia off, but the Rose Hill House was interesting. Old man Hillerman had built and operated it with his wife, but like so many of the small resorts in the Catskills, it had died a rather abrupt death in the mid-sixties and become a haven for memories and dreams, a monument to a bygone era when the railroad was in existence up here and moderately priced family vacations were in vogue.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Carl Palmer, Cynthia’s father, had begun his agency insuring such places because most of the other agencies were afraid of something they had prejudicially labeled, “Jewish lightning,” a fire in a resort when the Catskills had a bad season. There was never a fire at the Rose Hill House, but Ralph Hillerman, like the children of many other resort families, had no interest in continuing with the traditions and the tourist business. He became a professional businessman in his own right, and the Rose Hill House—named after his mother, Hillerman shortened to Hill for advertisement reasons—became a drain and a burden to him. As long as his father, who had survived his mother by ten years, was vigorous and feisty, there was little he could do about it. But now with the old man nearly senile and confined to a wheelchair most of the day, the options were reduced. For the Hillermans the Rose Hill House had to come to an end.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia couldn’t help feeling sorry for the old man, even though she agreed with Ralph’s decision. She had met Ben Hillerman briefly when she went up to inspect the property. He made her feel like an undertaker measuring him for a coffin, and she was happy when Patsy took him to the kitchen to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He knows why I’m here,” she told Ralph.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh sure. Despite his condition, you’d be surprised at how much he understands,” Ralph Hillerman told her. “But he’s drifting in and out of reality more and more now. It would be cruel to prolong this any longer, even though they don’t come any tougher. He and my mother made this place work no matter what the cost. I hate to see it the way it is now. It’s a shadow of itself, just the way he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course I can’t see it the way you do,” Cynthia said, “but I feel the Rose Hill House still has character. You can sense it. There’s wisdom in these old walls and real drama. Think of the different people who had stayed here.” She inhaled as though she could smell the history in the old tourist house. Ralph smiled and shook his head in admiration of her enthusiasm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I never heard a real estate agent talk about property the way you do,” he said. “You make it sound alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, it is, in its way,” she said, and she believed it. That was her edge, what made her successful. She did much more than pay for her share of the space and facilities she took up at the Palmer Building. She never gave Jason the opportunity to present her with a statement of liabilities, and Stephen had to admit to her financial acumen. But she wasn’t as happy about all this as she could be.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When she told Paula Levy, her best friend, about it, Paula said, “You’re too successful. It makes Stephen feel unimportant, maybe even unnecessary. Believe me, men like to feel essential. As soon as you show them you can do without them, they whimper. You can hear it in their voices, in their sarcasm.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Paula, divorced, remarried, separated and currently reconciled, wasn’t someone to hold up as successful when it came to her relationships with men, but her coldly analytical way often cut to the truth. Like most everyone, Cynthia thought, Paula could see what was wrong with other people faster than she could see what was wrong with herself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lately Cynthia had been thinking that Paula might be right on the money with her theories. Just as Paula had predicted, she was beginning to detect a note of ridicule and sarcasm in Stephen’s words. It was a tone that was more characteristic of her brother, Jason, than of her husband. It was even in what he told her this morning when he called about the Bloomfields.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your big-time New York clients want to play in the mountains,” he said. How did he know it was only play? Why did he assume she’d be unsuccessful, or was Paula right—was he hoping she would fail? Was Stephen, with all the success he and Jason were having, jealous of her?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She knew Jason didn’t expect her to ever sell the Rose Hill House. Maybe he was responsible for making Stephen so cynical about, it. It was a big property, a real estate agent’s dream sale of the year. Still, wouldn’t it be wonderful if Stephen believed in her and encouraged her? It was amazing what a little optimism could do for a couple, the light it could add to their lives. Why couldn’t Stephen see that? What blinded him?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She put the coffee mug in the sink and went into the dining room to inspect her full figure in the mirror. Perhaps the cherry-pink skirt and frilly, blue blouse were too bright and too informal for these clients. This was big money, and she didn’t want to appear inexperienced. Everyone said she looked like a woman in her late teens or early twenties as it was. Very few strangers guessed she was thirty, and clients who spoke to her on the phone first always had this surprised look on their faces when they finally met her in person. It was as though they expected her to go get her mother. She did have that deep, Lauren Bacall voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A youthful appearance ran in her family. Her mother’s skin was smooth to the day she died, and her father never really looked his age. Jason was the same way, only in his case she wasn’t sure it was an asset. At thirty-two he still had the look of a college freshman—smooth, light skin with soft, very light brown hair. He shaved daily, but he could go for nearly a week before the evidence of a beard would show. Once he tried to grow a mustache. She figured he wanted to look older, but all he produced was a pale peach fuzz that was impossible to detect from more than ten feet away. He had her hazel-green eyes, or rather, she had his since he was two years older. He wasn’t much taller at five-foot-ten, and his slim, almost fragile build sometimes made them look like twins.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Stephen looked his thirty-five years. He was six-foot-one and wide shouldered. Recently he let his tight, athletic build slip, but he still had a strong, authoritative voice and a commanding presence. He was so dark skinned that he always looked tanned, and he had licorice-black hair and a beard that was so heavy he had long since given in to the two-hour shadow and grown a full beard. He kept it beautifully trimmed. Cynthia was happy with it because she felt it gave his face strength and brought out the brightness in his brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She remembered the week he grew it, because that was the only time she could recall Jason being jealous of him. He had told him it made him look straggly and disheveled. Appearance was such an important thing to Jason. He had even implied that Stephen’s beard would hurt business. But she had encouraged him and he had kept it. Now she wondered if her encouragement about anything could make a difference when it came to the business and his work with Jason.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("More and more these days Cynthia felt she had not only fallen in love with a different face, but with a different person. She had never expected him to be so monomaniacal about his work. He and Jason were in the process of building the biggest agency in the tri-county area. They had taken on fifty new companies and had expanded from life, home and car into more exotic realms like racehorses and even the fingers of a pianist. The agency had grown from a company of two agents to ten, not including Stephen and Jason. Now they were talking about opening a branch office in Orange County, as well. She hated to take Jason along when they went to dinner or a show. Inevitably they would talk shop and leave her to fend for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was the eighth year of her marriage, and she and Stephen had been talking about children for the past two. The discussion hadn’t gotten any more intense. She didn’t want to be the only one pushing for it. Paula had told her that unless the husband and the wife wanted children with the same fervor, they could become an instant burden for one or the other. It made sense.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Again, listening to Paula, she had developed a similar philosophy when it came to the lovemaking between her and Stephen. Her signals had to be received and returned with the same enthusiasm, or she would turn over and wait for another occasion. Lately she was doing that more and more, so she experimented with the new hairdo and waited to see his reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was surprised she would make such an abrupt change, but the surprise didn’t translate into immediate pleasure. He did look at her in a new way, but she thought he looked more amused than attracted. Paula said it was something he would have to get used to.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Men can’t be as impulsive,” she told her, “especially businessmen like Stephen and Jason. They have to check things out with their brokers first. Oh, don’t worry,” she added, “one day he’ll just look at you like he did when you two first met and he’ll say, ‘My God, you’re beautiful.’” They both laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If only that would happen, she thought. She looked at her watch, saw that it was time to go and hurried out of the house. She was anxious to start the day.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Stephen and Jason were busy with some investors when she arrived at the Palmer Building. Judy Dobbs, the secretary who worked for her as well as for Stephen, told her they were having a meeting about Florida condos.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Condos? Since when have they been interested in condos?” She really meant it to be only a private thought but she said it aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, it’s been a few weeks, Mrs. Warner,” Judy said. Cynthia could see the twenty-eight-year-old woman’s look of glee. Cynthia knew she had a crush on Stephen. Judy was un­married and somewhat socially immature, even though she was a good secretary. She had a plain face with dull brown eyes and a chubbiness that produced an emphatic double chin. She was continually on a diet, but she continually cheated on that diet, too. Cynthia saw her as no threat, but she was annoyed with the teenage-like pleasure she obviously got from knowing something about Stephen that she didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Really,” Cynthia said. She didn’t continue the conversation, but she couldn’t hide her unhappiness. This involves real estate, she thought. They should have had her in on the discussions or at least told her about it beforehand, but Stephen hadn’t even mentioned it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But she didn’t have a chance to pout about it because the Bloomfields were right on time. She had just picked up her phone to call Jason’s office and interrupt them when Judy buzzed. Cynthia told her to send them in immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She liked them because there was no look of surprise on their faces; no doubt in their eyes when they confronted her. She thought they were both probably in their fifties, but they had a youthful vibrancy that was infectious. Toby Bloomfield had a slim, well-proportioned body. She wore designer jeans and a blue, light cotton sweater. Sid Bloomfield, dressed in a tight-fitting black sweatshirt and jeans, was tall and slim, too. In fact they looked like graduate students from a Jack La Lanne health spa. They talked quickly and excitedly, and they had an optimism that matched her own this morning and foretold a definite sale.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They liked the area; they liked the ride up. It was much less in travel time than they expected. No problem to hop up here for a weekend. Why, they could even shoot up for an evening in the middle of the week if they wanted to. And the village … it was just as they had envisioned: one main street, small mom and pop stores, little or no traffic, laid-back and quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Like a Norman Rockwell painting,” Toby said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We call it economic depression up here,” Cynthia said. They laughed, but they were laughing at everything. She had never seen such a giggly, middle-aged couple, and she found herself feeling somewhat jealous of the joy they took in each other. She wondered whether or not Stephen and she would have that kind of closeness when they were the Bloomfields’ age, especially since they didn’t have it now.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On the way out she wanted to stop at Jason’s office and make some comment about the meeting they were having, but the Bloomfields were so anxious for her to take them to the property, she couldn’t hesitate for a moment. As soon as the Rose Hill House came into view, Toby Bloomfield became animated. She clapped her hands and moved about in the car like a child brought to Disneyland for the first time. Her husband was a little embarrassed by her excitement, but he was obviously just as pleased himself by what they were seeing. They went about the place like people who had found their long-lost home. Never had they expected to find anything so perfect on their first try.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s why we came up here so early,” Toby told her. “We have other listings to examine, but now I don’t know if we’ll even bother.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Marshall greeted them at the door. Ben Hillerman was still living there, but he was confined to his room on the bottom floor. They went through the remainder of the house—the large kitchen and big dining room, the two sitting rooms and the large living room with the fieldstone fire-place that took up an entire wall. They checked the upstairs rooms and even climbed up the small attic ladder to take a peek into the area that now housed some old furniture, knickknacks and family heirlooms.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I wouldn’t be surprised if Ralph Hillerman left some of that stuff here with the house.” Cynthia caught the way the Bloomfields looked at each other when she said that and she thought, “frosting on the cake,” an old trick she learned from her father—hold back on some goody until the end and then just slip it in casually.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Afterward the Bloomfields went out to walk over the grounds and look at the lake. Cynthia left them alone for a while. She knew the way houses were really sold. If you were too anxious to sell it, used too many high-pressure techniques, people were often frightened off. It was better to let her clients ease into the sale like someone easing into a hot bath. Customers usually talked themselves into something faster than she could talk them into it anyway, once the preliminaries were done. These two were well on their way toward doing it. She watched them from the kitchen window that faced the rear of the property and turned away when Mrs. Marshall came in to get something.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How’s Mr. Hillerman doing?” she asked. Patsy Marshall was a diminutive woman with gentle, kind eyes. Cynthia could understand why Ralph would be upset about losing her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He sleeps most of the day now. He has only two or three hours of real lucidity, although when he’s lucid he has an amazing memory for details from the first half of his life. Don’t ask him to remember what he did yesterday, but fifty years ago …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How sad.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Marshall shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maybe it’s the mind’s way to remember only when you were younger, stronger and healthy. Sometimes when he drifts off I think he’s better off. It’s less painful than his realizing what’s happening.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I suppose you’re right,” Cynthia said. She started to think about how difficult it was sometimes to recall some of the happier moments of her own youth. Her thoughts were interrupted when she and Mrs. Marshall heard the old man call from his room. Cynthia went along with her to see him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She remembered him only vaguely from her youth, but when she had seen him the last time and when she saw him now, he looked shriveled and small, his face drawn and sallow, his eyes opened too widely. It was as though he had seen the coming of his own death and was startled by what it meant. He had fallen asleep in his wheelchair, apparently waking without calling for Patsy and then getting himself into his dresser drawers, pulling out old papers, letters and documents. Most of them were scattered about; he had attacked them with vehemence, either out of anger or frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hello there, Mr. Hillerman,” Cynthia said. He looked up at her and nodded as though she had been there for days. “Looks like you had an accident, huh?” she asked, smiling. He didn’t reply; he looked around the room as though just realizing where he was.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He goes through these papers every once in a while,” Mrs. Marshall said, looking up from the floor. She was on her hands and knees gathering it all together.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s he looking for?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who knows? Something different each time probably,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is that a newspaper clipping?” Cynthia asked, pointing to something just to her right.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It looks very old.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mrs. Marshall picked it up and studied it for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re right. This says 1935. Someone put it in this plastic sheet to preserve it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Laminated it,” Cynthia said. “Otherwise it might have crumpled into nothing years ago. What is it about?” She looked at the old man because she felt the intensity of his stare while Mrs. Marshall read the article.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“News story about a murder,” she said. She turned it over and then sat back on the floor. Cynthia watched her read. When she stopped and looked up at her, there was a strange expression on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She was a tourist, killed right here, but …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, look at the picture of this woman, the woman who was killed. Doesn’t she look a lot like … like you?” Mrs. Marshall said. Cynthia reached for the clipping slowly and studied the picture. There was a very strong resemblance, strong enough to give her the chills. She looked at old man Hillerman again. This time she thought she detected a slight smile in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Makes me feel as though I lived before,” Cynthia said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They say everyone has a twin somewhere at some time,” Mrs. Marshall said. “There’s yours. Or, there was yours.” Cynthia nodded and looked at the article again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“‘FAMILY DISPUTE TURNS VIOLENT,’” Cynthia read, quoting the headline. She looked toward the old man to see his reaction, but his eyes were closed. “Mr. Hillerman, who was this Karla Hoffman?” she asked, but he didn’t open his eyes or respond. He looked asleep. She read some more and then turned to Patsy Marshall. “According to this, the murder came as a complete surprise to everyone. No one knew the brother and sister were having difficulties, not even her husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I never heard that story.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Me, neither.” She took a step toward the old man. “I wish he would talk about it. Mr. Hillerman?” He didn’t even wince.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who knows if he’d remember anything anyway?” Mrs. Marshall said. She continued gathering the papers together to put back into the drawers. Cynthia nodded and looked at the picture again. She was more than simply fascinated with the resemblance; she was hypnotized with the look in the murdered woman’s eyes. It was as though the picture came to life in her hands. She felt a great need to keep it in her possession.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maybe his son will remember something,” Cynthia said. “If you don’t mind, I’ll take this and ask him about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t care.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They heard the Bloomfields call from the front entrance. Cynthia stepped farther into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’d appreciate it if you wouldn’t say anything about this that my clients might hear. People are funny about things like this. There’s a house in Glen Wild in which two people committed suicide and no realtor has been able to sell it since.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t matter to me who buys this place. I’m leaving in less than a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thanks,” she said. “I’d better get back to them,” she added when they called for her again. She headed out, but when she reached the mirror in the hall she stopped, looked at the picture of the murdered woman, looked at herself in the mirror and shuddered. It was enough to end the run of optimism she was having because it threw a pall over the house and made the shadows that lingered in the corners look ominous. Despite what she usually told prospective clients, it was impossible to ignore the impact of the events that occurred in a house and separate them from the structure itself. It depressed her, but when she met the Bloomfields on the front porch that depression was short-lived.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We’ll take it,” Sid Bloomfield said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She decided not to show the article to Stephen or to Jason. She knew they would mock her interest in it. Jason, especially, would say it wasn’t “Palmeresque,” a term he invented to describe the way Carl Palmer’s children should behave. To be fascinated with something that was so coincidental it was almost supernatural would be illogical and silly. After all, “we have an image in this community, a responsibility toward who we are and what we’ve accomplished.” That was Jason’s credo, and more and more it had become Stephen’s, as well. She was disgusted with his attitude; it was almost as though they were a different breed of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cynthia hated to be ridiculed. At times she thought Jason drew a sadistic pleasure from that fact. He had a knack for “getting her goat,” as her mother used to say. Jason and she were never very close as children. Even though they were relatively close in age, they had no common interests. Her theory was that Jason skipped childhood. He was studious, a loner, precocious, and at the age of ten, already bored with childish things. She remembered him winning the science-project contest when he was only in the eighth grade. It was a county-wide contest that included older students right up through the senior year. She remembered him reading "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Crime and Punishment")]), _vm._v(" in the ninth grade while his classmates struggled with the novella, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Pearl")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sometimes, when she was desperate about her homework, she would go to him for help. He was never really a big brother to her; he was always more like a tutor. But he didn’t have the patience to be a good tutor. He couldn’t understand why she would have any difficulty grasping concepts he understood instantly. Later on, when he was in college and she was finishing high school, he blamed her slower academic pace on her “female flightiness.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As long as she could remember, Jason did have a lower opinion of women. There was a distinct difference between the way he would talk to their father and the way he would talk to their mother. Her mother chose to ignore it, but even when Cynthia was a little girl she could detect the note of disdain in Jason’s voice whenever it came to academic things or business.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The only girlfriend she recalled him having in high school was that Lydia Morris, a pimply-faced, chunky girl with a weird fascination with biology. Cynthia would never forget the day she came home from cheerleading practice and found the two of them in the basement dissecting a cat that had been hit by a car on their block. Lydia said they couldn’t waste the opportunity. When Cynthia told her mother, though, she chased them both out and had the area disinfected. Jason never forgave her for telling on him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had very few friends in high school, and he participated in few extracurricular activities. He wasn’t athletic or very interested in sports. He didn’t even come to one basketball game to watch her as a cheerleader. Instead he ridiculed her for it, but his ridicule was subtle. He implied that that was all she was capable of doing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After college he was different, especially when he became an executive in the firm. She always had the feeling that something had happened to him during that last year in school, something that made him take a more objective look at himself. He had matured and become stable and strong. Although he was still quite arrogant, she found she admired him for his quick business sense and his fastidious manners.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Too many of the boys she had gone with proved uncouth, coarse and narrow-minded. Jason was a true intellectual. He had become engrossed in the firm, but he never lost his love of music, theater and books. She had to admit that he had a good influence on Stephen in this respect. Even though she was often left out of their conversations because she wasn’t familiar with the authors or the music they discussed, she welcomed the change in conversation. It was when they could be most interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At dinner parties they often commanded the attention of the gathering. They seemed to have the best political insights, the clearest perception of the significances in the manifestations on Wall Street and the most awareness of the latest current events. What one didn’t know, the other provided. What was it Sally Rothman said? “For you it must be like being escorted by monarchs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They did move like princes through this community. Other businessmen had taken to asking their advice on various matters. She was sure she didn’t know half the extent of their investments in local and state projects. And whenever she discovered something they were doing and then confronted Stephen about it, he would say, “But, Cynthia, I thought we told you about that” or “But, Cynthia, you were there when we were discussing it.” For all she knew she might have been. She had probably tuned herself out as she had done so many times before. At the end she would think, why should I care anyway? It’s not my passion. Let them become entrepreneurs or whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She enjoyed what she was doing: traveling the countryside, looking for and at new listings, meeting people and learning about their lives, their histories, the histories of their homes and their property. For her it was an ongoing saga, a never-ending soap opera of the highest quality. Whenever people called her in to sell their homes and property, they invariably felt they had to explain the reasons why they wanted to pull up roots. Some people improved their lot in life, but many fled their failures.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Cynthia returned to her office, she put Jody Dobbs right on the papers for the Rose Hill House. The Bloomfields wanted to take her to lunch, but she pretended she had a meeting with another client. The discovery of the old newspaper clipping and the photograph of the victim had put her into a very serious mood. The Bloomfields were too flighty. Suddenly she resented wealthy people who could purchase a property as large as the Rose Hill House as quickly and as easily as most people purchased toothpaste.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But it wasn’t them so much as it was herself. She was fascinated with the newspaper picture, fascinated with the face of Karla Hoffman. As she studied it in the privacy of her office, she saw more and more of a resemblance. Was her imagination running away with itself or were all the similarities there? How could this be? How could two people from two entirely different backgrounds look so much alike? Was it a toss of the genes, a coincidental combination?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And suppose that were true—it was only a coincidence. Why did she have such a deep, overriding affinity for this long dead woman? She couldn’t deny what she felt, and she couldn’t flee from it as people could flee from their properties. The more she stared at the amazingly identical face, the more she felt it was telling her something. But what … what?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She looked up quickly at the knock on her door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Congratulations,” Stephen said. “Judy just told us about your sale.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She put the article under some papers on her desk and sat back in her chair. He stood just inside the doorway. She had forgotten what he had worn this morning, the light blue sports jacket and slacks with his shirt opened at the collar. He looked radiantly masculine and confident, but at this moment, without really understanding why, she hated him for it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you. I guess it pays to be optimistic sometimes,” she added. If he understood her implication, he ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What did Ralph Hillerman have to say? I know he wasn’t very optimistic about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh my God. I forgot to call him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I … I just forgot to call him,” she said. She sat forward, surprised herself at such a major oversight. She looked at the papers that covered the old news article and realized that it was the story and the picture that had done this to her. It had had the effect of taking her out of reality, out of the present. She looked up at Stephen, who wore this annoyingly amused look on his face, and for a moment she considered telling him about the article. But she was afraid he would turn it around and use it as an example of how important it was to follow a prescribed procedure. That was Jason’s new kick these days: following procedures. For all she knew he probably lived his personal life the same way, even brushing his teeth the exact same time every morning. She had told them “following procedures” would stifle her creativity, and Jason had laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What can be creative about selling real estate?” he had said, and she had reddened, not because he had belittled what she did but because Stephen hadn’t come to her defense, as she had expected he would.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t believe this. Wait until Jason hears about it. Talk about dizzy women,” Stephen said. He hadn’t closed her office door behind him, and she was sure Judy Dobbs was listening keenly to every word. Before the day was over every secretary in the building would know about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Wait a minute,” she said, straightening up quickly. “I know why I got distracted. What’s this talk about Florida condos?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s a project Jason’s been developing … something called time-sharing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know what time-sharing is. What I want to know is how come nobody thought to tell me about it. I thought I had something to do with the real estate end of this agency.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, it isn’t exactly real estate the way you think of it, Cynthia. It’s more of a business venture.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A business venture in real estate. It means the same thing, Stephen. I resent not being told about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sorry. I’ll speak to Jason about it, and we’ll have a meeting. Nothing’s been confirmed yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I had to hear about it from my secretary,” she said, lowering her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, okay, I said I was sorry. You’d better call Ralph Hillerman,” he added, backing out. He looked as if he was in a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Where are you going now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jason and I have a lunch meeting with some people over at the racetrack.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did it ever occur to you that I might want to come along?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, not this time, but you could have asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re right. I’ve just been going at it so hot and heavy and I …”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, maybe you ought to pause for a while, Stephen, and think more about us.” She put her hand on the papers covering the newspaper article. Maybe she should show it to him, she thought; maybe he would stay with her and talk about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right. We’ll go to dinner tonight. To Dede’s. You love their lobster.” He started to close her door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just the two of us!” she said before it closed. Then she pulled the article out from under the papers and looked at the picture again. It reminded her about Ralph Hillerman this time, so she made the call. He was absolutely ecstatic.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was my father any problem?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. They didn’t even see him,” she said, and then thought about the article and the picture before her. The face stared up at her with an eerie expectation. “What are you doing right now?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Doing? I was on my way to lunch in Liberty.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You owe me one,” she said. “Can you pick me up?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Really? Sure. I’ll be there in fifteen minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After she hung up she sat back and thought for a moment. Something was bothering her about the old news story, and it was more than the uncanny likeness between her and the victim, Karla Hoffman. Some detail … some fact … she looked at the article again and read it for the fourth time since she had taken it from Mrs. Marshall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” she said, the heat coming into her face, “that’s it.” She sat back and stared at her closed office door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Karla Hoffman had been thirty years old when she was murdered, the same age Cynthia was now.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18b6d64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/978150408440622.vue
// module id = 72
// module chunks = 0